import { z } from 'zod';

import { AlertTaskSchema } from '@/alerts/entities/task';

import { AlertLevelSchema } from './alert-level';
import { AlertStatusSchema } from './alert-status';
import { AlertTypeSchema } from './alert-type';
import { DeviceBaseSchema } from './device';

export const AlertSchema = z.intersection(
  DeviceBaseSchema.pick({
    id: true,
    fullFrontendId: true,
  }),
  z.object({
    systemFrontendId: z.string().optional(),
    level: AlertLevelSchema,
    type: AlertTypeSchema,
    status: AlertStatusSchema,
    suggestedAction: z.string(),
    changedAt: z.date(),
    task: AlertTaskSchema.optional(),
  }),
);

export type Alert = z.infer<typeof AlertSchema>;
